import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { detectIconById, getCookie } from '../common/enum';
import {numeralFormat} from '../common/numeralFormat';

const ACTIONS_PLAYER = {
    GET_HEADER_PLAYER_PERFORMANCE_SUCCESS: 'GET_HEADER_PLAYER_PERFORMANCE_SUCCESS',
    GET_HEADER_PLAYER_PERFORMANCE_ERROR: 'GET_HEADER_PLAYER_PERFORMANCE_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const GetPlayerPerformance = (playerId, is_farm) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/players/${playerId}/years/results?is_farm=${is_farm}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS_PLAYER.GET_HEADER_PLAYER_PERFORMANCE_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_PLAYER.GET_HEADER_PLAYER_PERFORMANCE_ERROR, err));
            });
    };

};


const convertDataPlayerPerformanceBatter = (list) => {

    if (list) {
        return list.map(it => {
            return {
                item: [
                    { text: it.year },
                    {
                        text: '',
                        img: (it.team_id) ? detectIconById(it.team_id) : '', 
                        url: (it.team_id) ? '/team-report/' + it.team_id : '',
                        teamName: (it.team_name) ? it.team_name : '',
                        link: !!it.team_id
                    },
                    { text: it.g },
                    { text: it.pa },
                    { text: it.ab },
                    { text: it.r },
                    { text: it.h },
                    { text: it.h2b },
                    { text: it.h3b },
                    { text: it.hr },
                    { text: it.tb },
                    { text: it.rbi },
                    { text: it.so },
                    { text: it.bb },
                    { text: it.ibb },
                    { text: it.hbp },
                    { text: it.sh },
                    { text: it.sf },
                    { text: it.sb },
                    { text: it.cs },
                    { text: it.gidp },
                    { text: it.e },
                    { text: numeralFormat(it.avg, 3) },
                    { text: numeralFormat(it.slg, 3) },
                    { text: numeralFormat(it.obp, 3) },
                    { text: numeralFormat(it.ops, 3) }
                ]
            }
        })
    }
}

const convertDataPlayerPerformancePitcher = (list) => {
    if (list) {
        return list.map(it => {
            return {
                item: [
                    { text: it.year },
                    {
                        text: '',
                        img: (it.team_id) ? detectIconById(it.team_id) : '', 
                        url: (it.team_id) ? '/team-report/' + it.team_id : '',
                        teamName: (it.team_name) ? it.team_name : '',
                        link: !!it.team_id
                    },
                    { text: it.era },
                    { text: it.g },
                    { text: it.gs },
                    { text: it.cg },
                    { text: it.sho },
                    { text: it.mushikyu },
                    { text: it.gf },
                    { text: it.w },
                    { text: it.l },
                    { text: it.sv },
                    { text: it.hld },
                    { text: it.hp },
                    { text: numeralFormat(it.wpct, 3) },
                    { text: it.ip },
                    { text: it.bf },
                    { text: it.h },
                    { text: it.hr },
                    { text: it.bb },
                    { text: it.hbp },
                    { text: it.so },
                    { text: it.wp },
                    { text: it.bk },
                    { text: it.r },
                    { text: it.er },
                    { text: numeralFormat(it.avg, 3) },
                ]
            }
        })
    }
}

export {
    ACTIONS_PLAYER, GetPlayerPerformance, convertDataPlayerPerformancePitcher, convertDataPlayerPerformanceBatter
};
